import { UserActionsMenuItemConfig } from "../../../../../shared/components/topBarNewButtonMenu/TopBarNewButtonMenu"
import { createTopBarNewMenuItem } from "../../../../../shared/components/topBarNewButtonMenu/topBarNewMenuItems"
import { CreateOrderType } from "../../../../../shared/components/createOrder/helpers"
import { ModuleName } from "../../../../users/userTypes"

type ModuleToItemFactory = Readonly<{
    moduleName: ModuleName
    create: () => UserActionsMenuItemConfig
}>

export const moduleItemFactories = (
    params: Readonly<{
        handleCreateOrder: (type: CreateOrderType) => void
        handleOpenMakePurchase: () => void
        handleRefillWallet: () => void
    }>,
): ModuleToItemFactory[] => [
    {
        moduleName: ModuleName.BOOKING,
        create: () =>
            createTopBarNewMenuItem("resource-booking", () =>
                params.handleCreateOrder(CreateOrderType.RESOURCE_BOOKING),
            ),
    },
    {
        moduleName: ModuleName.CATERING,
        create: () =>
            createTopBarNewMenuItem("meeting-service", () => params.handleCreateOrder(CreateOrderType.MEETING_SERVICE)),
    },
    {
        moduleName: ModuleName.TAKE_AWAY,
        create: () =>
            createTopBarNewMenuItem("take-away", () => {
                // TODO: logic for takeaway
            }),
    },
    // Hide for now as we don't make orders page for this
    // {
    //     moduleName: ModuleName.APP_PAYMENT,
    //     create: () => createTopBarNewMenuItem("make-purchase", () => params.handleOpenMakePurchase()),
    // },
    {
        moduleName: ModuleName.REFILL_WALLET,
        create: () =>
            createTopBarNewMenuItem("refill-wallet", () => {
                params.handleRefillWallet()
            }),
    },
]
